import { memo } from "react"

import { OvermapIcon } from "../../components/Icons/OvermapIcon"

// This component shows a crosshair in the middle of the screen that lets the user choose a location for an issue
// The crosshair is the icon of the issue's marker, and it has a fancy background glow
export const LocationCrosshair = memo(() => {
	return (
		<div
			className="pointer-events-none fixed left-1/2 top-1/2 z-[500] -translate-x-1/2 -translate-y-1/2"
			draggable={false}
		>
			<svg
				className="relative bottom-[35px]"
				width="40"
				height="70"
				viewBox="0 0 40 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M40 19.8582C40 8.8908 31.0457 0 20 0C8.9543 0 0 8.8908 0 19.8582C0 35.7447 13.3333 59.9054 20 70C26.6667 59.74 40 35.3475 40 19.8582Z"
					fill="var(--primary-9)"
					stroke="var(--base-1)"
				/>
				<OvermapIcon className="**:fill-(--primary-contrast)" width="40" height="40" />
			</svg>
		</div>
	)
})

LocationCrosshair.displayName = "IssueCrosshair"
